import { useSelector } from 'react-redux';

export const useAllowMassActions = () => {
  const allowMassActions = useSelector(
    (store) => store.authentication.userInfo.CanMassChangeRequests
  );
  return allowMassActions;
};
